import React, { Component } from 'react';
import { Modal, Form, Card, Container, Col, Button, Row } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown';
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";

import { components } from 'react-select'
import { MenuItem } from 'react-bootstrap';
import { log } from 'logrocket';
import Select from "react-select";

const ADD_STUDENT_ALLOTMENT_DETAILS = gql`
  mutation(
    $params:AddStudentAllotmentDetails  
    ) {
        addStudentAllotmentDetails(
        params: $params
     )
  }
`;
const DELETE_EXISTING_ROOM_STUDENTS = gql`
mutation(
  $params:DeletedStudents  
  ) {
    deleteExistingRoomStudents(
      params: $params
   )
}
`;

const options = [
    { label: "Customer", value: "Customer" },
    { label: "Country", value: "Country" },
    { label: "Prefecture", value: "Prefecture" },
    { label: "Site", value: "Site" }
];

class AddBuildingModal extends Component {
    constructor() {
        super();
        this.state = {
            branchSearch: "",
            branchError: "",

            buildingSearch: "",
            buildingError: "",

            floorSearch: "",
            floorError: "",

            roomSearch: "",
            roomError: "",

            dataClear: 1,
            studentFilterData: [],
            defaultvalue: 0,
            getBuildings: [],
            getFloors: [],
            getRooms: [],
            capacityDetails: [],
            capacityCount: 0,
            showInputFields: false,
            studentnameSearchval: [],
            submitError: "",
            multiStuSubmitError: "",
            submitted: false,
            loadingSpin: 0
        }
    }

    handleAllocationChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "branchSearch") {
            if (value != 0 && value != "") {
                console.log("value", this.props.getNewEducationalStudents);
                let studentFilterData = this.props.getNewEducationalStudents.filter((item) => item.branch_id == +value)
                console.log("studentFilterData", studentFilterData);
                this.setState({
                    branchSearch: value,
                    studentFilterData: studentFilterData,
                    branchError: "",
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getBuildings: [],
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
                this.getBuildingCreationDetails(value);
            } else {
                this.setState({
                    branchSearch: "",
                    studentFilterData: [],
                    branchError: "",
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getBuildings: [],
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
            }

        }
        if (name == "buildingSearch") {
            let getFloors = []
            if (value != 0 && value != "") {
                getFloors = this.state.getBuildings.filter((item) => item.hostel_building_id == value)[0].floors_details
                console.log("getFloors", getFloors);


                this.setState({
                    buildingSearch: value,
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: getFloors,
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false

                })
                return ""
            } else {
                this.setState({
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
            }

        }
        if (name == "floorSearch") {
            let getRooms = []
            if (value != 0 && value != "") {
                console.log("floorFilterData", this.state.getFloors, value);

                getRooms = this.state.getFloors.filter((item) => item.floor_id == value)[0].rooms_details;
                console.log("floorFilterData", getRooms);

                this.setState({
                    floorSearch: value,
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getRooms: getRooms,
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })
                return ""
            } else {
                this.setState({
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getRooms: [],
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false
                })

            }
        }
        if (name == "roomSearch") {
            let capacityDetails = []
            console.log("val", this.state.getRooms);
            if (value != 0) {
                capacityDetails = this.state.getRooms.filter((item) => item.room_id == value);
                let details = [];
                console.log("floorFilterData", capacityDetails, this.state);

                if (capacityDetails[0].capacity_details.length > 0) {

                    let uniquecapacityDetails = [];

                    if (capacityDetails[0].capacity_details.length > 0) {
                        uniquecapacityDetails = capacityDetails[0].capacity_details.filter((item, index, array) => {
                            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                        })
                    }

                    console.log("details", uniquecapacityDetails);
                    if (capacityDetails[0].capacityCount == uniquecapacityDetails.length) {


                        uniquecapacityDetails.map((item) => {
                            let filterStudentsData = this.state.studentFilterData.find((item1) => item1.student_id == item.edu_student_id);
                            details.push({ value: `${item.edu_student_id}`, label: `${filterStudentsData.student_name}(${filterStudentsData.roll_no})` })
                        })

                    } else {
                        let laggingCapacitylength = capacityDetails[0].room_capacity - uniquecapacityDetails.length;
                        uniquecapacityDetails.map((item) => {
                            let filterStudentsData = this.state.studentFilterData.find((item1) => item1.student_id == item.edu_student_id);
                            console.log("helllo", item, filterStudentsData);
                            details.push({ value: `${item.edu_student_id}`, label: `${filterStudentsData.student_name}(${filterStudentsData.roll_no})` })
                        })
                        Array.from({ length: laggingCapacitylength }, (_, index) => {
                            details.push({ value: 0, label: "Select..." })
                        })
                    }

                } else {
                    Array.from({ length: capacityDetails[0].room_capacity }, (_, index) => {
                        details.push({ value: 0, label: "Select..." })
                    })
                }


                this.setState({
                    roomSearch: value,
                    roomError: "",
                    capacityDetails: capacityDetails[0].capacity_details,
                    capacityCount: capacityDetails[0].room_capacity,
                    studentnameSearchval: details,
                    showInputFields: true,
                    multiStuSubmitError: "",
                    submitError: ""
                })
            } else {
                this.setState({
                    roomSearch: "",
                    roomError: "",
                    capacityDetails: [],
                    capacityCount: 0,
                    showInputFields: false,
                    multiStuSubmitError: "",
                    submitError: ""
                })
            }
        }
    }

    getBuildingCreationDetails = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id: Int! $branch_id: Int!){
                getBuildingCreationDetails(institute_id: $institute_id branch_id:$branch_id) {
                    hostel_building_id
                    hostel_building_name
                    floors_details{
                      floor_id
                      floor_name
                      rooms_details{
                        room_id
                        room_name
                        room_capacity
                        capacity_details{
                          edu_student_id
                        }
                      }
                    }
                }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val)
            },
            fetchPolicy: 'network-only'
        })
        console.log("ttt", result.data.getBuildingCreationDetails);
        if (result.data.getBuildingCreationDetails.length > 0) {
            let filter_data = result.data.getBuildingCreationDetails

            if (filter_data.length > 0) {
                this.setState({
                    getBuildings: filter_data,
                    loadingSpin: 0
                })
            }
        }
    }

    // handleStudentChange = (index) => (event) => {
    //     const selectedValue = event.target.value;
    //     let updatedSearchval = [];

    //     this.state.studentnameSearchval.map((item, i) => {
    //         if (index == i) {
    //             updatedSearchval.push({ edu_student_id: +selectedValue })
    //         } else {
    //             updatedSearchval.push({ ...item })
    //         }
    //     })

    //     this.setState({ studentnameSearchval: updatedSearchval, multiStuSubmitError: "", submitError: "" });

    // };



    handleStudentChange = (index, e) => {
        const selectedValue = e.value;
        let updatedSearchval = [];
        this.state.studentnameSearchval.map((item, i) => {
            if (index == i) {
                if (selectedValue != 0) {

                    let filterStudentsData = this.state.studentFilterData.find((item1) => item1.student_id == selectedValue);
                    updatedSearchval.push({ value: `${selectedValue}`, label: `${filterStudentsData.student_name}(${filterStudentsData.roll_no})` })
                } else {
                    updatedSearchval.push({ value: 0, label: "Select..." })

                }
            } else {
                updatedSearchval.push({ ...item })
            }
        })

        this.setState({ studentnameSearchval: updatedSearchval, multiStuSubmitError: "", submitError: "" });
    }

    handleSubmit = () => {
        if (this.state.branchSearch == "") {
            this.setState({
                branchError: "Please select Branch"
            })
            return ""
        }
        if (this.state.buildingSearch == "") {
            this.setState({
                buildingError: "Please select Building"
            })
            return ""
        }
        if (this.state.floorSearch == "") {
            this.setState({
                floorError: "Please select Floor"
            })
            return ""
        }
        if (this.state.roomSearch == "") {
            this.setState({
                roomError: "Please select Room"
            })
            return ""
        }

        const uniqueStudentIds = new Set();
        let hasDuplicates = false;

        this.state.studentnameSearchval.forEach((item) => {
            if (item.value !== 0) {
                if (uniqueStudentIds.has(item.value)) {
                    hasDuplicates = true;
                    return;
                }
                uniqueStudentIds.add(item.value);
                console.log("uniqueStudentIds", uniqueStudentIds);
            }
        });

        if (hasDuplicates) {
            this.setState({
                multiStuSubmitError: "Please select unique students.",
                loadingSpin: 0
            });
            return;
        }

        const filteredStudentNames = this.state.studentnameSearchval.filter((item) => item.value !== 0);

        console.log("kkkk", filteredStudentNames);

        let students = [];

        filteredStudentNames.map((item) => {
            students.push({ edu_student_id: parseInt(item.value) })
        })
        const params = {
            room_id: parseInt(this.state.roomSearch),
            inserted_by: parseInt(Cookies.get("id")),
            room_capacity: students
        }


        this.setState({
            loadingSpin: 1
        })

        this.addStudentAllotmentDetails(
            params
        ).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpin: 0
            });

            console.error("ERR =>", error.graphQLErrors.map(x => x.message));

            if (error.graphQLErrors.map(x => x.extensions).length > 0 && error.graphQLErrors.map(x => x.extensions)[0].code == "BAD_USER_INPUT" && students.length > 0) {
                if (window.confirm(this.state.submitError)) {
                    this.studentConfirmAllotment();
                }
            }

        });


    }

    addStudentAllotmentDetails = async (
        params) => {
        await this.props.addStudentAllotmentDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addStudentAllotmentDetails) {
                    this.setState({
                        loadingSpin: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1000)
                }
            }

        });

    };


    //second confirm mutation
    studentConfirmAllotment = () => {
        const filteredStudentNames2 = this.state.studentnameSearchval.filter((item) => item.edu_student_id !== 0);
        let students2 = [];

        filteredStudentNames2.map((item) => {
            students2.push({ edu_student_id: parseInt(item.value) })
        })
        const params = {
            room_id: parseInt(this.state.roomSearch),
            inserted_by: parseInt(Cookies.get("id")),
            room_capacity: students2
        }
        this.setState({
            loadingSpin: 0
        })
        this.deleteExistingRoomStudents(
            params
        ).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpin: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));

        });

    }


    deleteExistingRoomStudents = async (
        params) => {
        await this.props.deleteExistingRoomStudents({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.deleteExistingRoomStudents) {
                    this.setState({
                        loadingSpin: 0,
                        submitted: true
                    })
                    if (this.state.submitted == true) {
                        this.handleSubmit();
                    }
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1000)
                }
            }

        });

    };


    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            console.log("update");


            this.setState({
                dataClear: 1,
                branchSearch: "",
                branchError: "",
                buildingSearch: "",
                buildingError: "",
                floorSearch: "",
                floorError: "",
                roomSearch: "",
                roomError: "",
                studentFilterData: [],
                defaultvalue: 0,
                getBuildings: [],
                getFloors: [],
                getRooms: [],
                capacityDetails: [],
                capacityCount: 0,
                showInputFields: false,
                studentnameSearchval: [],
                submitError: ""
            })

            let existingModalDetails = this.props.stateData
            let studentFilterData1 = this.props.getNewEducationalStudents.filter((item) => item.branch_id == existingModalDetails.branchSearch)
            let getStudents = existingModalDetails.getStudentData;

            if (existingModalDetails.isEdit) {
                this.setState({
                    branchSearch: existingModalDetails.branchSearch,
                    buildingSearch: existingModalDetails.activeBuildingDetails.toString(),
                    floorSearch: existingModalDetails.activeFloorDetails.toString(),
                    roomSearch: existingModalDetails.activeRoomDetails.toString(),
                    capacityCount: existingModalDetails.activeCapacityDetails,
                    studentFilterData: studentFilterData1,
                    showInputFields: true,
                    getBuildings: existingModalDetails.getBuildingData,
                    getFloors: existingModalDetails.getFloorData,
                    getRooms: existingModalDetails.getRoomData,

                })

                setTimeout(() => {
                    let e = {
                        target: {
                            name: "roomSearch",
                            value: existingModalDetails.activeRoomDetails.toString()
                        }
                    }


                    this.handleAllocationChange(e)

                }, 0)

            }
        }

        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }

    }

    render() {
        console.log("sssssssss", this.state);

        const filteredStudent = this.state.studentnameSearchval.filter((item) => item.value !== 0);

        let studentArr = [];

        filteredStudent.map((item) => {
            studentArr.push({ edu_student_id: item.value })
        })

        let studentsData = [];

        if (this.state.studentFilterData.length > 0) {
            let obj = {
                label: "Select...",
                value: 0
            }
            studentsData.push(obj)

            this.state.studentFilterData.map((item) => {
                studentsData.push({ label: `${item.student_name}(${item.roll_no})`, value: item.student_id })
            })
        }
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered

            >

                <div style={{ backgroundColor: "rgb(249,235,222)" }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Student Room Allocation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <Row>
                            <Col lg={3} md={3} sm={12} className="mb-2">
                                <Form.Group as={Col} >
                                    <Form.Label className='font-weight-bold fs-5'>Branch</Form.Label>
                                    <Form.Control as="select" name="branchSearch" onChange={this.handleAllocationChange} value={this.state.branchSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {this.props.globals.globalBranches.map(item => (
                                            <option value={item.id}>{item.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={3} sm={12} className="mb-2">
                                <Form.Group as={Col} >
                                    <Form.Label className='font-weight-bold fs-5'>Building Name</Form.Label>
                                    <Form.Control as="select" name="buildingSearch" onChange={this.handleAllocationChange} value={this.state.buildingSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {this.state.getBuildings.map(buildname => (
                                            <option value={buildname.hostel_building_id}>{buildname.hostel_building_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.buildingError}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={3} sm={12} className="mb-2">
                                <Form.Group as={Col} >
                                    <Form.Label className='font-weight-bold fs-5'>Flour Name</Form.Label>
                                    <Form.Control as="select" name="floorSearch" onChange={this.handleAllocationChange} value={this.state.floorSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {this.state.getFloors.map(floorname => (
                                            <option value={floorname.floor_id}>{floorname.floor_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.floorError}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={3} sm={12} className="mb-2">
                                <Form.Group as={Col} >
                                    <Form.Label className='font-weight-bold fs-5'>Room Number</Form.Label>
                                    <Form.Control as="select" name="roomSearch" onChange={this.handleAllocationChange} value={this.state.roomSearch} disabled={this.props.stateData.isEdit == true ? true : false}>
                                        <option value={this.state.defaultvalue}>--Select--</option>
                                        {this.state.getRooms.map(roomno => (
                                            <option value={roomno.room_id}>{roomno.room_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.roomError}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {
                                this.state.showInputFields == true ?
                                    <Col lg={12} className="mb-2">

                                        <Row>
                                            {[...Array(this.state.capacityCount)].map((_, index) => (
                                                <Col key={index} lg={4} md={4} sm={12}>
                                                    <Form.Group as={Col} >
                                                        <Form.Label className='font-weight-bold fs-5'>Allocate Student</Form.Label>
                                                        <div class="row p-2">
                                                            <div className="col-md-12 col-sm-12">
                                                                <Select
                                                                    options={studentsData}
                                                                    onChange={(e) => { this.handleStudentChange(index, e) }}
                                                                    name="studentData"
                                                                    value={this.state.studentnameSearchval[index]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </Col>

                                            ))}
                                        </Row>
                                        <Row className='text-center' >
                                            <Col>
                                                <Button className='btn btn-success' onClick={this.handleSubmit}>
                                                    {
                                                        this.state.loadingSpin == 1 ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : ""
                                                    }
                                                    Submit</Button>
                                                <div>
                                                    {
                                                        this.state.submitted == true ? (
                                                            <p className="text-success mt-1" >Allocated Successfully</p>
                                                        ) : ""
                                                    }
                                                    {
                                                        this.state.multiStuSubmitError != "" ? (
                                                            <span className="text-danger mt-1">{this.state.multiStuSubmitError}</span>
                                                        ) : ("")
                                                    }
                                                    {
                                                        this.state.submitError != "" && studentArr.length == 0 ? (
                                                            <span className="text-danger mt-1">{this.state.submitError}</span>
                                                        ) : ("")
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col> : ""
                            }
                        </Row>
                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_STUDENT_ALLOTMENT_DETAILS, {

        name: "addStudentAllotmentDetails"
    }),
    graphql(DELETE_EXISTING_ROOM_STUDENTS, {

        name: "deleteExistingRoomStudents"
    }),
)(AddBuildingModal)));
